import {SignRole} from '@bumpy/i18n_common';

const key = 'role';

export function saveRole(role: SignRole): void {
  localStorage.setItem(key, role);
}

export function getRole(): SignRole {
  return localStorage.getItem(key) as SignRole;
}

export function deleteRole(): void {
  localStorage.removeItem(key);
}
